import React, { useLayoutEffect } from 'react'
import isEqual from 'react-fast-compare'

import DraftAnnotationPopover from '../DraftAnnotationPopover'
import AnnotationDot from '../AnnotationDot'

import {
  useAnnotationPopover,
  useDotCoordinateStyle,
  useAnnotationOverlayContext,
} from '../../hooks'
import {
  ReferenceBounds,
  DraftAnnotation as DraftAnnotationType,
} from '../../types'

import { Button } from './DraftAnnotation.styles'
import { AnnotationDotFragment } from '@sketch/gql-types'

interface DraftAnnotationProps {
  draftAnnotation: DraftAnnotationType
  referenceBounds: ReferenceBounds
  parentWrapper?: HTMLElement
  onSubmit?: (annotation: AnnotationDotFragment) => void
}

const DraftAnnotation = (props: DraftAnnotationProps) => {
  const { draftAnnotation, referenceBounds, parentWrapper, onSubmit } = props
  const { coordinates, context, prefixBounds } = draftAnnotation
  const annotationContext = useAnnotationOverlayContext()

  const style = useDotCoordinateStyle({
    coordinates,
    referenceBounds,
    prefixBounds,
  })

  const [content, buttonProps, { update }] = useAnnotationPopover({
    parentWrapper,
    dropdown: DraftAnnotationPopover,
    dropdownProps: {
      coordinates,
      parameters: context,
      isViewingLatestVersion: Boolean(
        annotationContext?.isViewingLatestVersion
      ),
      onSubmit: ({ createAnnotation }) => {
        onSubmit?.(createAnnotation.annotation)
      },
    },
  })

  /**
   * Update the position of the popover
   * when the coordinates are updated
   */
  useLayoutEffect(() => {
    update?.()
  }, [coordinates, update])

  return (
    <>
      {content}
      <Button {...buttonProps} style={style}>
        <AnnotationDot flavour="new" selected />
      </Button>
    </>
  )
}

export default React.memo(DraftAnnotation, isEqual)
